import LocationLink from '../../../modules/Location/components/LocationLink';
import BinIcon from '../../../components/icon/Icon';
import { MobileMenuItemBadgeStyled, MobileMenuItemStyled } from './styled/MobileMenuStyled';
import { IMobileMenuItemConfig } from './mobileMenu.t';
import { useLangContext } from '../../../providers/LangProvider/LangProviderContext';
import { useCallback } from 'react';
import { logAppsflyerAction } from '../../../app/appActions';
import { LOG_AF_EVENT_NAMES } from '../../../app/appConstants';
import { useLocation } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { getUserSelectedAccountType } from '../../../app/appSelectors';
import _ from 'lodash';

interface IMobileMenuItemProps {
    config: IMobileMenuItemConfig;
}

function MobileMenuItem(props: IMobileMenuItemProps) {
    const { config } = props;
    const { getLangPath } = useLangContext();
    const { pathname } = useLocation();
    const selectedAccountType = useSelector(getUserSelectedAccountType);
    const dispatch = useDispatch();
    const isVisible = useSelector(config.isVisibleSelector || _.stubTrue);
    const isShowBadge = useSelector(config.isShowBadgeSelector || _.stubFalse);

    const onClickHandler = useCallback((e) => {
        const location = e.currentTarget.dataset.location;
        dispatch(logAppsflyerAction({
            name: LOG_AF_EVENT_NAMES.APP_TAB_CLICK,
            payload: {
                account_type: selectedAccountType,
                current_tab: pathname,
                new_tab: location,
            },
        }));
    }, [dispatch, pathname, selectedAccountType]);

    if (!isVisible) return null;

    return <MobileMenuItemStyled
        className={config.to === pathname ? 'active' : ''}
        data-to={config.to}
        data-location={config.locationName}
        onClick={onClickHandler}
    >
        <LocationLink locationName={config.locationName}>
            <div className={'position-relative d-inline-block'}>
                <BinIcon name={config.icon}/>
                {isShowBadge && <MobileMenuItemBadgeStyled/>}
            </div>
            <div className={'title'}>{getLangPath(config.title)}</div>
        </LocationLink>
    </MobileMenuItemStyled>;
}

export default MobileMenuItem;
